import { Injectable }                                             from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../services/auth.service';
import { HttpResponseHandlerService } from '../services/http-response-handler.service';

@Injectable()
/**
 * Requires a currently logged in user
*/
export class UserLoggedInAuthGuard implements CanActivate {

    constructor(private _auth: AuthService,
        private router: Router,
        private httpResponseHandlerService: HttpResponseHandlerService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // check auth service
        if (!this._auth.hasApplicationAccess) {
            this.httpResponseHandlerService.displayAccessDenied('You are not currently logged in. You must log in to continue');
            this.router.navigate(['/']);
            return false;
        }
        return this._auth.hasApplicationAccess;
    }

}
